import { render } from "./xxqk.vue?vue&type=template&id=0c008e91&scoped=true&ts=true"
import script from "./xxqk.vue?vue&type=script&lang=ts"
export * from "./xxqk.vue?vue&type=script&lang=ts"

import "./xxqk.vue?vue&type=style&index=0&id=0c008e91&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c008e91"]])

export default __exports__